import { PROVINCE_OPTIONS } from '@myap/metadata'
import { reduxForm, getFormValues } from 'redux-form'
import {
  fetchStudentLocation,
  updateStudentLocation,
  resetStudentLocation,
} from '../../actions/updateStudent'
import { Error, Text, Select, Button, ApIdValidation } from '../../components/common'
import { getUpdateStudentData, getUpdateStudentStatusProps } from '../../selectors/updateStudent'
import {
  UPDATE_STUDENT_LOCATION_FORM,
  UPDATE_STUDENT_LOCATION_FIELDS as FIELDS,
} from '../../constants/UpdateStudentConstants'
import { isEmpty } from '../../utils/common'

const mapStateToProps = state => {
  const { data } = getUpdateStudentData(state)
  const { fetching, submitting, submitted, error } = getUpdateStudentStatusProps(state)
  const currentValues = getFormValues(UPDATE_STUDENT_LOCATION_FORM)(state)
  const initialValues = {
    [FIELDS.studentId.name]: data?.apId,
    [FIELDS.province.name]: data?.[FIELDS.province.name],
  }

  return {
    fetching,
    submitting,
    submitted,
    error,
    data,
    initialValues,
    currentValues,
  }
}

const UpdateStudentLocationForm = ({
  fetching,
  submitting,
  submitted,
  error,
  data,
  currentValues,
  handleSubmit,
  fetchStudentLocation,
}) => {
  const hasProvinceOptions = Object.keys(PROVINCE_OPTIONS).find(p => p === data?.countryCode)

  const handleSearch = async () => {
    await fetchStudentLocation({ studentId: currentValues?.[FIELDS.studentId.name] ?? '' })
  }

  return (
    <form onSubmit={handleSubmit}>
      <Text
        name={FIELDS.studentId.name}
        label="Select Student"
        placeholder="Enter AP ID"
        isRequired={FIELDS.studentId.required}
        isSearchBox={true}
        validate={[ApIdValidation]}
      />
      <Button
        label="Search"
        isPrimary={true}
        isDisabled={isEmpty(currentValues?.[FIELDS.studentId.name]) || fetching}
        onClick={handleSearch}
        busy={fetching}
      />
      {!isEmpty(data) && !submitted ? (
        <>
          <h2 className="cb-spacerv-sm-top">Student Information</h2>
          <dl>
            <dt className="cb-no-margin-left">Legal First Name:</dt>
            <dd className="cb-no-margin-left cb-spacerv-xs-bottom">{data?.firstName}</dd>
            <dt className="cb-no-margin-left">Last Name:</dt>
            <dd className="cb-no-margin-left cb-spacerv-xs-bottom">{data?.lastName}</dd>
            <dt className="cb-no-margin-left">Person ID:</dt>
            <dd className="cb-no-margin-left cb-spacerv-xs-bottom">{data?.personId}</dd>
          </dl>
          {hasProvinceOptions ? (
            <>
              <Select
                name={FIELDS.province.name}
                label="Select location"
                isRequired={true}
                showEmptyOption={true}
                options={PROVINCE_OPTIONS[data?.countryCode]}
                placeholder="Choose"
                normalize={val => parseInt(val, 10)}
              />
              <Button
                label="Submit"
                isPrimary={true}
                isDisabled={isEmpty(currentValues?.[FIELDS.province.name]) || submitting}
                isSubmit={true}
                busy={submitting}
                style={{ marginBottom: '24px' }}
              />
            </>
          ) : null}
        </>
      ) : null}
      {error ? <Error message={error} /> : null}
    </form>
  )
}

export default connect(mapStateToProps, {
  fetchStudentLocation,
  updateStudentLocation,
  resetStudentLocation,
})(
  reduxForm({
    form: UPDATE_STUDENT_LOCATION_FORM,
    enableReinitialize: true,
    onSubmit: async (values, dispatch, { updateStudentLocation }) => {
      await updateStudentLocation({
        studentId: values?.[FIELDS.studentId.name],
        provinceCode: parseInt(values?.[FIELDS.province.name], 10),
      })
    },
    onSubmitSuccess: (result, dispatch, { resetStudentLocation }) => resetStudentLocation(),
  })(UpdateStudentLocationForm)
)
